import React, { useContext } from "react";
import {
    ModalContainer,
    Content,
    IconContainer,
    TextContainer,
    Title,
    Description,
    Footer,
    CancelButton,
    DeleteButton,
    IconCircle,
} from "./RemoveGatewayModal.styles";
import DeleteIcon from "../../../../../../images/gateways/delete.svg";
import { StyledModal } from "../../../Gateways.styles";
import { ApplicationContext } from "../../../../../../components/ApplicationProvider";
import Parser from "html-react-parser";

export type RemoveGatewayModalProps = {
    open: boolean;
    gatewayName: string;
    isDeleting?: boolean;
    onCancel: () => void;
    onDelete: () => void | Promise<void>;
};

const RemoveGatewayModal: React.FC<RemoveGatewayModalProps> = ({
    open,
    gatewayName,
    isDeleting = false,
    onCancel,
    onDelete,
}) => {
    const { t } = useContext(ApplicationContext);

    return (
        <StyledModal
            open={open}
            onClose={onCancel}
            closeOnDimmerClick={false}
            data-testid="remove-gateway-modal"
        >
            <ModalContainer data-testid="remove-gateway-modal-container">
                <Content data-testid="remove-gateway-modal-content">
                    <IconContainer data-testid="remove-gateway-modal-icon-container">
                        <IconCircle data-testid="remove-gateway-modal-icon-circle">
                            <img
                                src={DeleteIcon}
                                alt="Delete"
                                data-testid="remove-gateway-modal-delete-icon"
                            />
                        </IconCircle>
                    </IconContainer>

                    <TextContainer data-testid="remove-gateway-modal-text-container">
                        <Title data-testid="remove-gateway-modal-title">
                            {t("devices.gateways.gateway_card.remove_gateway_title")}
                        </Title>

                        <Description data-testid="remove-gateway-modal-description">
                            {Parser(
                                t("devices.gateways.gateway_card.remove_gateway_description", {
                                    gatewayName,
                                })
                            )}
                        </Description>
                    </TextContainer>
                </Content>

                <Footer data-testid="remove-gateway-modal-footer">
                    <CancelButton
                        type="button"
                        onClick={onCancel}
                        disabled={isDeleting}
                        data-testid="remove-gateway-cancel-button"
                    >
                        {t("devices.cancel")}
                    </CancelButton>

                    <DeleteButton
                        type="button"
                        onClick={onDelete}
                        disabled={isDeleting}
                        data-testid="remove-gateway-delete-button"
                    >
                        {t("devices.delete_gateway")}
                    </DeleteButton>
                </Footer>
            </ModalContainer>
        </StyledModal>
    );
};

export default RemoveGatewayModal;
